module.exports = __webpack_public_path__ + "img/lida.6743b73a.png";